import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import BaseCard from "../baseCard";
import {AutoSizer} from 'react-virtualized';
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import SettingsIcon from "@material-ui/icons/Settings";

const useStyles = makeStyles(theme => ({
    root: {},
    content: {},
    contentPaper: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(3),
        verticalAlign: 'middle',
        display: 'inline-flex',
        borderRadius: theme.spacing(1),
        overflowY: 'auto',
    },
}));

const GettingStartedCard = props => {
    const classes = useStyles();

    return (
        <AutoSizer>
            {({height, width}) => {
                return (
                    <BaseCard title={"Getting Started"} height={height} width={width}>
                        <Paper className={classes.contentPaper} style={{height: height - 60}}>
                            <div className={classes.content}>
                                <Typography color="primary" variant="h5">
                                    Welcome to JunctionBox.io!
                                </Typography>
                                <p>This is a quick overview of our app and how to use it.</p>
                                <p>To start, JunctionBox.io is a Relationship Toolbox that helps people manage their
                                    connections with other people.</p>
                                <p>As of now, JunctionBox.io works best with <a href={"https://www.google.com/chrome"}>Google
                                    Chrome</a>. If you are not using Chrome, you may want to download it and use it for
                                    JunctionBox.io.</p>
                                <p>If you have not already done so, you should install our Chrome extension. It really
                                    adds value to what we are doing. Click on the gear menu (<SettingsIcon
                                        style={{fontSize: 16}}/>) in the upper right corner of JunctionBox.io and choose
                                    Install Chrome Extension. Then install as you would any other Chrome extension. If
                                    you do not have access to the extension, send me an email and I will add you to the
                                    alpha list.</p>
                                <Typography color="secondary" variant="h6">Some Basics</Typography>
                                <ul>
                                    <li><strong>LinkedIn</strong> - With the extension installed, you can browse to any
                                        web page. You can select any text, right click, choose a JunctionBox tool, and
                                        add the selection to your contact database. <span style={{color: 'red'}}>You may need to refresh the page to see
                                            our menu. This is a known problem we are working on.</span>
                                    </li>
                                    <li><strong>Feedback</strong> - Under the gear menu (<SettingsIcon
                                        style={{fontSize: 16}}/>) in the upper right corner, there is a "Send Feedback"
                                        button. Please use this to let us know about anything. In fact, you can use it
                                        now to just say hi.
                                    </li>
                                    <li><strong>Dashboard</strong> - The Dashboard contains several widgets to show
                                        information at a glance. We are adding widgets and functionality. If you want
                                        something to help you, please let us know. You can use the feedback form and
                                        upload a sketch or an example if you like.
                                    </li>
                                    <li><strong>Tasks</strong> - Tasks are ToDo items you wish to schedule out into the
                                        future. They can be related to a contact, an account, or just a general
                                        task. For example, you can set yourself a task to call John tomorrow.
                                    </li>
                                    <li><strong>Activities</strong> - Activities (right now) look a lot like Tasks. That
                                        will change. The Activities list should contain anything that has gone on
                                        between you and a contact or an account. That will include outgoing emails,
                                        calls, meetings, incoming requests, etc.
                                    </li>
                                    <li><strong>Contacts</strong> - If you have never used a CRM (like Salesforce)
                                        before, you may not know what a Contact is. A Contact is any person to whom you
                                        wish to stay connected. In our case, Contacts will contain everyone you have
                                        visited on LinkedIn as well as anyone you have added manually.
                                    </li>
                                    <li><strong>Accounts</strong> - Like Contacts, Accounts are organizations with which
                                        you wish to stay connected. In our case, Accounts will contain every company you
                                        have visited on LinkedIn and anyone you have added manually. It will also
                                        provide organizations for which your contacts have worked for.
                                    </li>
                                </ul>
                                <p><span style={{color: 'red'}}>We are currently in the ALPHA test mode. If you are using this software, it is
                                    because you were invited to do so. We appreciate you working through our growing
                                    pains you might experience. And we welcome your feedback. Thanks for your help!</span>
                                </p>
                            </div>
                        </Paper>
                    </BaseCard>
                );
            }}
        </AutoSizer>
    )
};

export default GettingStartedCard
